module.exports = __webpack_public_path__ + "img/mirian.16e68141.png";